import TouristGroupObjectValue from '../ObjectValue/TouristGroup';

const TouristGroupFactory = function (data) {
    let results = null;
    // Обработка старого формата данных
    if (data.adults !== undefined || data.kids !== undefined || data.infants !== undefined) {
        const singleGroup = createFromSingleGroup(data);
        if (singleGroup) {
            results = new TouristGroupObjectValue(singleGroup);
        }
    }
    
    // Обработка нового формата с touristsByRooms
    if (data.touristsByRooms && Array.isArray(data.touristsByRooms)) {
        const roomGroups = createFromMultipleRooms(data.touristsByRooms);
        if (roomGroups) {
            results.set('touristsByRooms', roomGroups);
        }
    }
    return results;
};

const createFromSingleGroup = (data) => {
    const touristGroup = {};
    
    if (isValidNumericData(data)) {
        return null;
    }
    
    touristGroup.adults = normalizeAdults(data.adults);
    touristGroup.kids = normalizeKids(data.kids);
    touristGroup.infants = normalizeInfants(data.infants, touristGroup.kids);
    
    touristGroup.ages = Array.isArray(data.ages) ? data.ages.map(Number) : [];
    const infantsAges = touristGroup.ages.filter((age) => age <= 1).slice(0, touristGroup.infants);
    const kidsAges = touristGroup.ages.filter((age) => age > 1).slice(0, touristGroup.kids);
    if(infantsAges.length !== touristGroup.infants) {
        const differenceCount = Math.abs(infantsAges.length - touristGroup.infants);
        touristGroup.ages.push(...new Array(differenceCount).fill(0));
    }
    if(kidsAges.length !== touristGroup.kids) {
        const differenceCount = Math.abs(kidsAges.length - touristGroup.kids);
        touristGroup.ages.push(...new Array(differenceCount).fill(11));   
    }
    
    return touristGroup;
};

const createFromMultipleRooms = (touristsByRooms) => {
    const validRooms = touristsByRooms
        .map(roomData => createFromSingleGroup(roomData))
        .filter(room => room !== null);
    
    return validRooms.length > 0 ? validRooms : null;
};

const isValidNumericData = (data) => 
    (data.adults && Number.isNaN(+data.adults)) || 
    (data.kids && Number.isNaN(+data.kids)) || 
    (data.infants && Number.isNaN(+data.infants));

const normalizeAdults = (adults) => {
    const adultsCount = Math.max(1, +adults || 1);
    return Math.min(adultsCount, 6);
};

const normalizeKids = (kids) => {
    const kidsCount = Math.max(0, +kids || 0);
    return Math.min(kidsCount, 3);
};

const normalizeInfants = (infants, kidsCount) => {
    const infantsCount = Math.max(0, +infants || 0);
    return Math.min(infantsCount, 3 - kidsCount);
};

export default TouristGroupFactory;